import { useEffect, useState } from 'react';
import { FaqSection } from '../../../../../api/types/faq-content-api';
import { RouteComponentProps } from 'react-router-dom';
import HelpCenterBreadcrumbs from '../Breadcrumb/HelpCenterBreadcrumbs';
import { IBreadcrumb, BreadcrumbSeoScript } from '../Breadcrumb/BreadcrumbSeoScript';
import { buildFaqBreadcrumb } from '../Breadcrumb/breadcrumbHelper';
import '../../../../../../scss/pages/help-center/main.scss';
import { redirectToHelpCenter } from '../../../utils';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useMuiMediaQuery } from '../../../../../utilities/hooks';
import OtherTopics from '../Shared/OtherTopics';
import NeedMoreHelp from '../Shared/NeedMoreHelp';
import RelatedQuestions from '../Shared/RelatedQuestions';

interface IFaqSectionPageProps {
    location: RouteComponentProps['location'];
    allSections: FaqSection[] | undefined;
}

export const FaqSectionPage = ({ location, allSections }: IFaqSectionPageProps) => {
    const [faqSection, setFaqSection] = useState<FaqSection>();
    const [otherTopics, setOtherTopics] = useState<FaqSection[]>();
    const [breadcrumb, setBreadcrumb] = useState<IBreadcrumb[]>();
    const { isMobile } = useMuiMediaQuery();

    useEffect(() => {
        if (allSections) {
            const getSectionByPath = allSections?.find((section: { url: string }) =>
                section.url.match(new RegExp(`${location.pathname}$`, 'i')),
            );
            if (!getSectionByPath) redirectToHelpCenter();
            !faqSection && setFaqSection(getSectionByPath);
            !otherTopics && setOtherTopics(allSections?.filter((x) => x.sectionTitle !== faqSection?.sectionTitle));
            !breadcrumb && faqSection && setBreadcrumb(buildFaqBreadcrumb(faqSection));
        }
    }, [faqSection, allSections, location.pathname, otherTopics, breadcrumb]);

    useEffect(() => {
        const title = faqSection?.seoTags?.title;
        if (title) {
            document.title = title;
        }
    }, [faqSection?.seoTags?.title]);

    return (
        <>
            {faqSection ? (
                <Container id="page--faq-section" maxWidth="md">
                    {breadcrumb && <BreadcrumbSeoScript breadcrumb={breadcrumb} />}
                    <Stack spacing={1} sx={{ mt: { xs: 1, md: 3 }, mb: 9 }}>
                        {breadcrumb && <HelpCenterBreadcrumbs breadcrumb={breadcrumb} />}
                        <div data-testid="page-content">
                            <Stack spacing={5}>
                                <RelatedQuestions
                                    spacing={5}
                                    relatedQuestions={faqSection.faqs}
                                    title={
                                        <Typography color="textPrimary" component="h1" variant={isMobile ? 'h4' : 'h3'}>
                                            {faqSection.sectionTitle}
                                        </Typography>
                                    }
                                />
                            </Stack>
                        </div>
                    </Stack>
                    <Stack spacing={8} sx={{ mt: 8, pb: { xs: 8, md: 10 } }}>
                        <OtherTopics otherTopics={otherTopics} />
                        <NeedMoreHelp />
                    </Stack>
                </Container>
            ) : (
                <></>
            )}
        </>
    );
};
